import React from 'react';
import './GatewaySection.css';

const GatewaySection = () => {
  return (
    <section className="gateway-section" id="gateway-section">
      <div className="gateway-container">
        <div className="content-wrapper">
          <div className="label-wrapper">
            <span className="partner-label">Core Offerings</span>
          </div>
          <h2 className="gateway-title">
            A Path to <span className="highlight-blue">Success</span>
          </h2>
          <p className="gateway-description">
            Our services are designed to provide a clear, step-by-step path to market success, built on the foundation of our emic insights.
          </p>
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon icon-blue-bg">
                <span className="icon-text">💬</span>
              </div>
              <h4 className="feature-title">Tier 1: The Foundation Package</h4>
              <p className="feature-text">The essential first step, providing the strategic insights and connections you need to prepare for launch.</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon icon-blue-bg">
                <span className="icon-text">👥</span>
              </div>
              <h4 className="feature-title">Tier 2: The Acceleration Package</h4>
              <p className="feature-text">For brands ready to move beyond strategy and into active, on-the-ground execution.</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon icon-blue-bg">
                <span className="icon-text">⚙️</span>
              </div>
              <h4 className="feature-title">Tier 3: The Full-Scale Package</h4>
              <p className="feature-text">Your all-inclusive solution for a fully managed market entry and ongoing growth.</p>
            </div>
          </div>
          <a className="schedule-btn" href="#contact-section">
            Schedule Consultation <span className="arrow">→</span>
          </a>
        </div>

        {/* REMOVED: The entire <div className="video-wrapper"> block */}
        
      </div>
    </section>
  );
};

export default GatewaySection;